<template lang="pug">
div
  v-select.c-vselect(
    v-if='isSelect',
    :tabindex='inputTabindex',
    @input='updateState',
    @search='searchState',
    @search:focus='searchFocus',
    @search:blur='searchBlur',
    name='state',
    data-vv-as='state',
    v-validate='\'required\'',
    :value='value',
    autocomplete='address-level1',
    placeholder='- Select your state -',
    :options='states[country]',
    :reduce='(state) => state.label',
    :clearable='false',
    :class='{ "form-ctl--valid": !!value, "form-ctl--error": errors.has("state", scope) || errors.has("state", "server") }'
  )
  input(
    v-else,
    type='text',
    name='state',
    ref='input',
    :value='value',
    :id='inputId',
    :tabindex='inputTabindex',
    :placeholder='inputPlaceholder',
    @input='updateState($event.target.value)',
    :class='[inputClass, { error: errors.has("state", scope) }]',
    data-vv-as='state',
    v-validate='\'required|max:24\''
  )
  .form-ctl__error(v-show='errors.has(\'state\', scope)') {{ errors.first('state', scope) }}
  .form-ctl__error(
    v-show='errors.has(\'state\', \'server\')',
    v-text='errors.first("state", "server")'
  )
</template>
<script>
import Vue from 'vue';
import VueSelect from 'vue-select';
import { SERVICES } from '../../constants/service';

import us_states from '../../../../../../lib/data/shop/us_states';
import ca_states from '../../../../../../lib/data/shop/ca_states';
import jp_states from '../../../../../../lib/data/shop/jp_states';

Vue.component('v-select', VueSelect);

Object.defineProperty(exports, '__esModule', {
  value: true
});

const stateList = (states) => {
  let list = Object.entries(states).map(([label, value]) => ({
    label,
    value
  }));
  for (let key in list) {
    list[key].label = list[key].label
      .split('_')
      .map(function (w) {
        return '' + w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(' ');
  }
  return list;
};

let states = {};
states['US'] = stateList(us_states);
states['CA'] = stateList(ca_states);
states['JP'] = stateList(jp_states);

export default {
  inject: ['$validator'],
  data() {
    return {
      states: states,
      state: '',
      isSelectFocus: false
    };
  },
  props: {
    inputId: {
      type: String,
      default: ''
    },
    inputTabindex: {
      type: Number,
      default: 0
    },
    inputClass: {
      type: Object,
      default() {
        return {};
      }
    },
    inputPlaceholder: {
      type: String,
      default: ''
    },
    selectPlaceholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    service: {
      type: String,
      default: ''
    },
    scope: {
      type: String,
      default: 'shipping-address'
    }
  },
  computed: {
    isSelect() {
      if (!this.states[this.country]) {
        return false;
      }
      if (this.service !== SERVICES.PROJECTS && this.country === 'JP') {
        return false;
      }
      return true;
    }
  },
  methods: {
    updateState(value) {
      let formattedValue = '';
      if (!this.isSelect) {
        formattedValue = value.trim();
      } else {
        formattedValue = value;
      }
      if (formattedValue !== value) {
        this.$refs.input.value = formattedValue;
      }
      this.$emit('input', formattedValue);
    },
    /**
     * VueSelect をブラウザの自動入力に対応させるための処理（US/CAのみ）
     */
    searchFocus() {
      this.isSelectFocus = true;
    },
    searchBlur() {
      this.isSelectFocus = false;
    },
    searchState(value) {
      if (!this.isSelectFocus || !value) {
        return;
      }
      if (this.states[this.country].some((s) => s.label === value)) {
        this.updateState(value);
        return;
      }

      // 大文字の略名で入力された場合
      const abbrs = this.states[this.country].reduce((obj, data) => {
        obj[data.value] = data.label;
        return obj;
      }, {});
      if (abbrs[value]) {
        this.updateState(abbrs[value]);
      }
    }
  }
};
</script>
